import React, { Fragment } from 'react';
import FormBasic from 'v2/components/Pages/Product/Edit/Forms/Basic';
import FormDetails from 'v2/components/Pages/Product/Edit/Forms/Details';
import FormSupportRefund from 'v2/components/Pages/Product/Edit/Forms/SupportRefund';
import Content from 'v2/components/Shared/Content';

//Validations
import GeneralValidations from './validations';
import { useEditProduct } from '../../context';

function General() {
  const {
    basic,
    saveBasic,
    isLoadingBasic,

    details,
    saveDetails,
    isLoadingDetails,

    supportRefund,
    saveSupportRefund,
    isLoadingSupportRefund,
  } = useEditProduct();

  return (
    <Fragment>
      <Content>
        {[
          {
            id: 'basic',
            title: 'Dados básicos do produto',
            anchor: 'Dados Básicos',
            validations: GeneralValidations.basicSchema,
            submit: saveBasic,
            defaultValues: basic,
            isLoading: isLoadingBasic,
            content: (cProps: any) => <FormBasic {...cProps} />,
          },
          {
            id: 'details',
            title: 'Detalhes do Produto',
            anchor: 'Detalhes',
            validations: GeneralValidations.detailsSchema,
            submit: saveDetails,
            defaultValues: details,
            isLoading: isLoadingDetails,
            content: (cProps: any) => <FormDetails {...cProps} />,
          },
          {
            id: 'support_refund',
            title: 'Suporte e Reembolsos',
            anchor: 'Suporte e Reembolsos',
            validations: GeneralValidations.supportRefundSchema,
            submit: saveSupportRefund,
            defaultValues: supportRefund,
            isLoading: isLoadingSupportRefund,
            content: (cProps: any) => <FormSupportRefund {...cProps} />,
          },
        ]}
      </Content>
    </Fragment>
  );
}

export default General;
